module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/download_secondary.74514dcb0b4c499d9e58ea25afb54d31.svg";